import { Button, ButtonWithPopup, Text, Tooltip } from '@innovationdepartment/proxima-ui';
import { ArrowBackRounded } from '@mui/icons-material';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import { BackLink, ConfirmActions, ConfirmContent } from './shared.styles';

type BackToAudiencesLinkProps = {
  to: string;
  /**
   * When set, clicking the arrow asks with this message before leaving.
   * Keep editing closes the popup, and Discard follows the link.
   */
  confirmDiscard?: string | null;
  /** When true, the arrow stays put, e.g. while a create is submitting. */
  disabled?: boolean;
};

/** An arrow link back to the Custom Audiences list, for a page's `aboveTitle`. */
const BackToAudiencesLink = ({
  to,
  confirmDiscard,
  disabled = false
}: BackToAudiencesLinkProps) => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const holdNavigation = disabled || confirmDiscard != null;

  const link = (
    <Tooltip title="Custom Audiences">
      <BackLink
        to={to}
        aria-label="Back to Custom Audiences"
        aria-disabled={disabled || undefined}
        aria-haspopup={confirmDiscard != null && !disabled ? 'dialog' : undefined}
        onClick={event => {
          if (holdNavigation) event.preventDefault();
        }}
      >
        <ArrowBackRounded sx={{ fontSize: 20 }} />
      </BackLink>
    </Tooltip>
  );

  if (confirmDiscard == null) return link;
  return (
    <ButtonWithPopup
      open={open && !disabled}
      onOpen={() => {
        if (!disabled) setOpen(true);
      }}
      onClose={() => setOpen(false)}
      placement="bottom-left"
      buttonElement={link}
    >
      <ConfirmContent>
        <Text variant="body2">{confirmDiscard}</Text>
        <ConfirmActions>
          <Button label="Keep editing" variant="text" size="small" onClick={() => setOpen(false)} />
          <Button label="Discard" color="error" size="small" onClick={() => navigate(to)} />
        </ConfirmActions>
      </ConfirmContent>
    </ButtonWithPopup>
  );
};

export default BackToAudiencesLink;
